import React from 'react';

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import {
  updateEnquirySelection,
  updateModifiedInputs
} from '../store/slices/offerSlice';
import { Enquiry } from '../components/Enquiry/Enquiry';
import { FooterContainer } from '../containers/FooterContainer';
import {
  IPricingQuestion,
  IPricingStepConfig
} from '../interfaces/EnquiryInterface';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { AdditionalInputsContainer } from './AdditionalInputsContainer';
import { logMessage } from '../utils/loggers';
import { LoggingHelper } from '../utils/LoggingHelper';

export const MoreInputsContainer: React.FC<{ product: string }> = (props: {
  product: string;
}) => {
  const stepQuestions = useAppSelector((state) =>
    state.insurance.pricingQuestions.find(
      (item: IPricingStepConfig) => item.stepCode === '001'
    )
  );
  const additionalInputs = useAppSelector(
    (state) => state.insurance.additionalInputs
  );
  const customerNumber = useAppSelector((state) => state.insurance.offer.customerNumber);
  const dispatch = useAppDispatch();
  const handleChange = (
    type: string,
    value: string,
    isValid?: boolean,
    errorMessage?: string
  ) => {
    updateSelection(type, value, isValid, errorMessage);
  };
  const updateSelection = (
    type: string,
    value: string,
    isValid?: boolean,
    errorMessage?: string
  ) => {
    dispatch(
      updateEnquirySelection({
        questionType: type,
        selectedOption: value,
        stepCode: '001',
        isValid: !!isValid,
        errorMessage: errorMessage || ''
      })
    );
    const policyDetails = InsuranceHelper.retrievePolicyInfoFromURL();
    const { policyNumber: policyNumberFromUrl } = InsuranceHelper.getPolicyAndChannelFromUrl();
    const policyNumber = policyNumberFromUrl || policyDetails.policyNumber;

    if (policyNumber) {
      dispatch(
        updateModifiedInputs({
          selections: {
            key: type,
            value
          }
        })
      );
    }
  };
  const additionalInputsInvalidArea = InsuranceHelper.isAdditionalInputsInvalidArea(props.product, additionalInputs);
  if(additionalInputsInvalidArea) {
    logMessage(
      `Purchase flow blocked due to total additional building area exceeds 180sqm : customerNo: ${customerNumber} additionalBuildings: ${JSON.stringify(LoggingHelper.buildExtraBuildingData(additionalInputs))}`,
      {severity: 'INFO'}
    )
  }
  const isNextButtonDisabled =
    stepQuestions?.questions &&
    InsuranceHelper.isFormWithInvalidAnswer(stepQuestions?.questions)
    || additionalInputsInvalidArea;

  return (
    <>
      {stepQuestions &&
        stepQuestions.questions?.map(
          (item: IPricingQuestion, index: number) => {
            return (
              item.isVisible && (
                <div key={index}>
                  <Enquiry
                    data={item}
                    handleChange={handleChange}
                    alignCenter={false}
                    stepCode="001"
                    mainHeader={false}
                    isVertical={item.isVertical}
                  />
                </div>
              )
            );
          }
        )}
      {InsuranceHelper.isAdditionalInputsEnabled(props.product) && (
        <div className="pt-5">
          <AdditionalInputsContainer 
            isAdditionalInputsAreaInvalid={additionalInputsInvalidArea}
          />
        </div>
      )}
      <div className="pt-5 footer-section-wrapper">
        <FooterContainer isNextButtonDisabled={isNextButtonDisabled} />
      </div>
    </>
  );
};
